import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fNumber(number) {
  return numeral(number).format();
}

export function fCurrency(number) {
  return new Intl.NumberFormat('es-DO', {
    style: 'currency',
    currency: 'DOP'
}).format(number);
}

export function fCurrencyNoPrefix(number) {

  const formattedCurrency = new Intl.NumberFormat('es-DO', {
    style: 'currency',
    currency: 'DOP'
  }).format(number);

  // Eliminar el símbolo de la moneda
  return formattedCurrency.replace(/RD\$/g, '').trim();
}


export function addNumberToZeros(number, length) {
  // Convierte el número a una cadena
  const numberStr = number.toString();
  
  // Calcula cuántos ceros agregar
  const zerosNeeded = length - numberStr.length;
  
  // Si los ceros necesarios son negativos, significa que el número es demasiado grande
  if (zerosNeeded < 0) {
      throw new Error('El número es demasiado grande para el formato especificado.');
  }
  
  // Genera la cadena de ceros necesarios
  const zeros = '0'.repeat(zerosNeeded);
  
  // Devuelve el resultado final
  return zeros + numberStr;
}


export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}
